export const Types = {
  SUBMIT_CREATE_PRIZE: 'SUBMIT_CREATE_PRIZE',
  CREATE_PRIZE_COMPLETE: 'CREATE_PRIZE_COMPLETE',
  START_CREATE_PRIZE: 'START_CREATE_PRIZE',
  END_CREATE_PRIZE: 'END_CREATE_PRIZE',
  ERROR_CREATING_PRIZE: 'ERROR_CREATING_PRIZE'
};

export const submitCreatePrize = (title, lang, prizeType) => ({
  type: Types.SUBMIT_CREATE_PRIZE,
  title,
  lang,
  prizeType
});

export const createPrizeCompleted = (prizeId) => ({
  type: Types.CREATE_PRIZE_COMPLETE,
  prizeId
});

export const startCreatePrizeAction = () => ({
  type: Types.START_CREATE_PRIZE
});

export const endCreatePrizeAction = () => ({
  type: Types.END_CREATE_PRIZE
});

export const errorCreatingPrizeAction = (error) => ({
  type: Types.ERROR_CREATING_PRIZE,
  error: error
});



// WEBPACK FOOTER //
// ./public/pages/PrizeCreator/actions.js